import "./SegmentedControl.css";
import cn from "classnames";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

export type SegmentedOption<T extends string = string> = {
	value: T;
	label: ReactNode;
};

type Props<T extends string = string> = {
	options: SegmentedOption<T>[];
	value: T;
	onChange: (value: T) => void;
	ariaLabel?: string;
} & Omit<ComponentPropsWithoutRef<"div">, "onChange" | "children">;

export function SegmentedControl<T extends string = string>({
	options,
	value,
	onChange,
	ariaLabel,
	className,
	...rest
}: Props<T>) {
	return (
		// biome-ignore lint/a11y/useSemanticElements: this control is a button group, not a form fieldset
		<div
			className={cn("segmented-control", className)}
			role="group"
			aria-label={ariaLabel}
			{...rest}
		>
			{options.map((option) => (
				<button
					key={option.value}
					type="button"
					className={cn("segmented-control-item", {
						active: option.value === value,
					})}
					aria-pressed={option.value === value}
					onClick={() => onChange(option.value)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
}
